import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../constant";
import AppContext from "../../AppContext";
import AssetList from "./AssetList";
import AlarmList from "./AlarmList";
import Map from "./Map";
import Loader from "../Loader";
import { useTranslation } from "react-i18next";

function Home() {
  const { config, setAssets, assets, apiLoaded, darkMode } =
    useContext(AppContext);
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);
  const [searchedData, setSearchedData] = useState("");
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [assetType, setAssetType] = useState();

  const onSearch = (e) => {
    let value = e.target.value;
    setSearchedData(value);
  };

  useEffect(() => {
    const loadAssetType = async () => {
      let res = await axios.get(
        `${BASE_URL}/AssetType/${config.homeConfiguration?.id}`
      );
      setAssetType(res.data);
    };
    if (config?.homeConfiguration?.id !== undefined) loadAssetType();
  }, [config?.homeConfiguration?.id]);

  const cardClicked = async (asset) => {
    setAssets((pre) =>
      pre.map((v) =>
        v.id === asset.id
          ? { ...v, cardClicked: !v.cardClicked }
          : { ...v, cardClicked: false }
      )
    );
    if (selectedAsset === asset.id) {
      setSelectedAsset(null);
    } else {
      // await getPathCoordinates(asset);
      setSelectedAsset(asset.id);
    }
  };

  return (
    <div
      className={`${
        apiLoaded || (assets && assets.length > 0) ? "" : "animate-pulse"
      } dark:bg-darkModeHomeBg bg-lightModeBg flex flex-col lg:gap-0 lg:flex-row flex-grow  h-full w-screen overflow-scroll lg:overflow-hidden`}
    >
      <div className="hidden lg:flex flex-col flex-shrink-0 min-w-fit max-w-[450px] w-1/4 py-2">
        {(apiLoaded || (assets && assets.length > 0)) && (
          <AssetList
            onSearch={onSearch}
            searchedData={searchedData}
            setSearchedData={setSearchedData}
            cardClicked={cardClicked}
            assetType={assetType}
          />
        )}
      </div>
      <div
        className={`${
          open ? "h-96 min-h-[384px] lg:h-full" : "h-96 lg:h-full"
        } duration-500 ease-in-out py-2 w-full`}
      >
        {apiLoaded || (assets && assets.length > 0) ? (
          <Map selectedAsset={selectedAsset} assetType={assetType} />
        ) : (
          <div className=" flex justify-center items-center h-full">
            <Loader />
          </div>
        )}
      </div>
      <div
        className={`${
          open ? "lg:w-1/4 sm:w-full mt-2 md:min-w-fit flex-grow-0 " : "w-fit"
        } transition-all duration-500 ease-in-out flex mb-3 lg:max-w-[450px] md:h-auto h-full`}
      >
        <div className="flex lg:hidden w-1/2">
          <AssetList cardClicked={cardClicked} />
        </div>
        {open ? (
          <div className="flex flex-col w-1/2 lg:w-full flex-grow-0">
            <AlarmList setOpen={setOpen} open={open} />
          </div>
        ) : (
          <div className="flex flex-col gap-5 items-center bg-gradient-to-r from-red-800 to-orange-600 pt-5 rounded-lg w-10 mt-2 ml-2 mr-3 duration-500 ease-in-out">
            <div className="flex items-center relative ">
              <button type="button" onClick={() => setOpen(!open)}>
                <img src="Union.svg" alt="union" className=" text-orange-300" />
              </button>
            </div>
            <div>
              <div className="flex bg-red-600 rounded-full h-8 w-8 justify-center items-center">
                <div className="bg-red-500 w-5 h-5 rounded-full text-gray-300 font-semibold text-xs text-center pt-1 flex justify-center items-center">
                  10
                </div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <label className="font-semibold text-sm text-gray-300 -rotate-90">
                {t("home.alarmList.headerText")}
              </label>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Home;
